import { useMemo } from 'react'

import useTokens, { REBTC_MINT_ADDRESS, REETH_MINT_ADDRESS } from '@/hooks/use-tokens'
import { CustomTokenInfo } from '@/utils/helpers'

import View from './view'

type Props = {
  onClickToken: (token: CustomTokenInfo) => void
}

const Container = ({ onClickToken }: Props) => {
  const { reUsdTokenInfo, tokenListMap } = useTokens()

  const tokensList = useMemo(() => {
    return [
      reUsdTokenInfo,
      tokenListMap.get(REBTC_MINT_ADDRESS),
      tokenListMap.get(REETH_MINT_ADDRESS),
    ].filter(Boolean) as CustomTokenInfo[]
  }, [reUsdTokenInfo, tokenListMap])

  return <View onClickToken={onClickToken} tokensList={tokensList} />
}

export default Container
